import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { IComplianceProps } from "../../../leap-components/Compliance/IComplianceProps";
import { Column } from "react-table";
import EpaCard from "../../../leap-components/EpaCard";
import { Grid } from "../../../leap-components/Grid";
import { useState } from "react";
import { ILicenceProfile, IFPInstrument } from "../../../api/ILicenceProfile";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import EnvironmentalLiabilitiesDetails from "./EnvironmentalLiabilitiesDetails";
import { Col, Row } from "react-bootstrap";

const FinantialProvisionGrid = ({ licenceProfile }: IComplianceProps) => {
  const tableColumnsBig: Column<Record<string, IFPInstrument>>[] = [
    {
      Header: "Instrument Type",
      accessor: "type",
      Filter: false,
    },
    {
      Header: "Amount",
      accessor: "value",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<Record<string, IFPInstrument>>[] = [
    {
      Header: "Instrument Type",
      accessor: "type",
      Filter: false,
    },
    {
      Header: "Amount",
      accessor: "value",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={licenceProfile.fpinstruments.list}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={licenceProfile.fpinstruments.list}
        />
      </div>
    </div>
  );

  return (
    <EpaCard
      title={"Financial Provision Instruments in Place"}
      content={bodyElements}
    />
  );
};

const EnvironmentalLiabilitiesTab = () => {
  const [loading, setLoading] = useState(false);
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const dispatch = useAppDispatch();

  let { profileNo } = useParams();
  if (!profileNo) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <EnvironmentalLiabilitiesDetails
            licenceProfileDetails={licenceProfile}
          ></EnvironmentalLiabilitiesDetails>
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <FinantialProvisionGrid licenceProfile={licenceProfile} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          For further information, please visit the{" "}
          <a
            href="https://www.epa.ie/our-services/compliance--enforcement/industry-and-waste-management/financial-provision-for-environmental-liabilities/"
            target="blank"
          >
            financial provision for environmental liabilities page
          </a>{" "}
          on the EPA website
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="environmental-liabilities"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default EnvironmentalLiabilitiesTab;
